<div style="margin-left: 25px; margin-right: 25px; margin-top: 25px;">
  <div class="grid p-justify-between">
    <div class="col-2" style="font-weight: 100; font-size: var(--fontSizeBigger );">Upload Editor</div>
    <div class="col-3">Bezeichnung: {{ validationName$ | async }}</div>
    <div class="col-2">Listentyp: {{ listName$ | async }}</div>
    <div class="col-2">Geändert: {{ (lastChangeDate$ | async) | date: 'dd.MM.yyyy'}}</div>

    <div class="col-1"><p-button [disabled]="(rowValues$ | async).length < 1" class="right-0"  type="button"
      icon="pi pi-file-excel" [pTooltip]="getExportExcelTooltip()" tooltipPosition="left"  severity="info" appendTo="body"
    (click)="exportnachExcel($event)"></p-button></div>
    @if (canFoxxyImportAsync()) {
      <div class="col-1"><p-button  type="button" icon="pi pi-sign-out"
      pTooltip="Foxxy-Import" severity="success"  (click)="foxxyImport()"></p-button>
    </div>
  }
  <div class="col-1"><p-button class="right-0" type="button" icon="pi pi-times"
    [disabled]="isRowsEditing()"  [tooltipPosition]="'left'"
  pTooltip="Liste schliessen" severity="info" (click)="closeList()"></p-button></div>
  <p-toast></p-toast>
</div>
@if ((isReadOnly$ | async) == 1) {
  <div>{{isReadOnlyMessage$ | async }}</div>
}

<p-toolbar>
  <ng-template #start>
    @if (canLeftMenue()) {
      <div  class="flex items-center gap-2">
        @if (canExcelExportImport()) {
          <p-button [disabled]="!canVorlageExport()" [ngClass]="'rightMargin'"
            type="button" icon="pi pi-angle-double-down" pTooltip="Excel-Vorlage laden" severity="info"
          (click)="downloadListForTask($event)"></p-button>
        }
        @if (canExcelExportImport()) {
          <p-fileUpload [disabled]="!canExcelHochladen() "
            pTooltip="Excel Datei hochladen (vorhandene Daten werden ersetzt)" #fubauto mode="basic" auto="true"
            name="excelFile"
        url="{{ uploadServiceAddress + (uploadData$ | async).id + '&taskid=' + taskId + '&listName=' + (uploadData$ |async).attributeValidation }}"
        invalidFileTypeMessageSummary="{0} Datei nicht erlaubt" chooseLabel="Neu..."
        (onBeforeUpload)="onBeforeUpload($event)" (onUpload)="onUploadFinished($event, fubauto)"
        (onError)="uploadError($event, fubauto)" accept=".xlsx" maxFileSize="1000000">
      </p-fileUpload>
}
      @if (canExcelExportImport()) {
<p-fileUpload [disabled]="!canExcelHochladen() "
        pTooltip="Excel Datei hochladen (vorhandene Daten bleiben erhalten)" [ngClass]="'leftMargin'" #fubmerge
            mode="basic" auto="true" name="excelFile"
        url="{{ mergeServiceAddress + (uploadData$ | async).id + '&taskid=' + taskId + '&listName=' + (uploadData$ |async).attributeValidation }}"
        invalidFileTypeMessageSummary="{0} Datei nicht erlaubt" chooseLabel="Zusammenführen..."
        (onBeforeUpload)="onBeforeMergeUpload($event)" chooseIcon="pi pi-file-excel"
        (onUpload)="onMergeUploadFinished($event, fubmerge)" (onError)="uploadMergeError($event, fubmerge)"
        accept=".xlsx" maxFileSize="1000000">
      </p-fileUpload>
}
      @if (canExcelExportImport()) {
<span class="menuSeperator" ></span>
}
      <p-button id="addnewrow" [disabled]=" !canNewRow() "  type="button" icon="pi pi-plus"
        pTooltip="Neue Zeile" severity="info" (click)="addNewRow()"></p-button>

      @if ((uploadData$ | async).uploadState < 20) {
<span class="menuSeperator"></span>
}

        @if (isRowsEditing() == false) {
<p-button pTooltip="Bearbeiten" [disabled]="(isReadOnly$ | async) == 1  || (isManager && taskType == 'articledata')"
           type="button" icon="pi pi-pencil"
          severity="info" (click)="onEditInit()"></p-button>
}
        @if (isRowsEditing() == true ) {
<p-button [disabled]="(isReadOnly$ | async) == 1"  type="button"
          icon="pi pi-check" severity="success" [pTooltip]="'Bestätigen'"
          [style]="{'margin-left': '10px' , 'margin-right' :  '5px' }" (click)="onRowsEditSave()"></p-button>
        }
        @if (isRowsEditing() == true ) {
          <p-button [disabled]="(isReadOnly$ | async) == 1"  type="button"
            [pTooltip]="'Abbrechen'" icon="pi pi-times" [style]="{'margin-left': '10px' , 'margin-right' :  '5px' }" severity="danger"
          (click)="onRowsEditCancel()"></p-button>
        }
        @if (selectedRows.length > 0) {
          <span class="menuSeperator"></span>
        }
        @if (selectedRows.length > 0) {
          <p-button [disabled]="(isReadOnly$ | async) == 1"  type="button"
          icon="pi pi-trash" pTooltip="Markierte Löschen" severity="danger" (click)="deleteRows()"></p-button>
        }
        <span class="menuSeperator"></span>
        <p-button [disabled]="!canImportAllBubs()"  type="button" icon="pi pi-download"
          pTooltip="Alle Daten mit Bub-Informationen erweitern" severity="info"
        (click)="importAllFromBub()"></p-button>
        @if (this.taskType != 'articledata' && !isManager ) {
          <span class="menuSeperator"></span>
        }
        @if (this.taskType != 'articledata' && !isManager) {
          <p-button [disabled]="(isReadOnly$ | async) == 1"
          label="Ohne Input abschließen" type="button"  (click)="closewithOutAction()"></p-button>
        }
        @if (canFreigabeAbschliessen()) {
          <span class="menuSeperator"></span>
        }
        @if (canFreigabeAbschliessen()) {
          <span>
            <p-button [disabled]="(isReadOnly$ | async) == 1" type="button" icon="pi pi-sign-out"
              pTooltip="Freigeben / Abschliessen" severity="success" [style]="{'margin-left': '15px'}"
            (click)="finishUpload()"></p-button>
          </span>
        }
        @if (selectedRows.length > 0) {
          <span class="menuSeperator"></span>
        }
        @if (selectedRows.length > 0) {
          <span>
            <p-button [disabled]=" !canImportSelectedBubs() "  type="button" icon="pi pi-arrow-circle-down"
              pTooltip="Importieren von Bub-Daten für ausgewählte Artikel" severity="info"
            (click)="importSelectedFromBub()"></p-button>
          </span>
        }
        <!--   <span *ngIf="selectedRows.length > 0" class="menuSeperator"></span>
        <button [disabled]="(isReadOnly$ | async)" *ngIf="selectedRows.length > 0" pButton type="button"
        icon="pi pi-trash" pTooltip="Markierte Löschen" class="ui-button-danger" (click)="deleteRows()"></button>
        -->
      </div>
    }
  </ng-template>
  <ng-template #end>
    @if (this.taskType == 'task') {
      <div style="margin-top: 10px">
        <span style="margin-top: 10px;"><strong>Anzahl Zeilen Minimum: {{ minimum$ | async }} - Maximum: {{ maximum$ |
        async }}</strong> - Aktuell: {{ (rowValues$ | async).length }} - Markiert: {{ selectedRows.length }}</span>
        <span style="margin-left: 15px;"><strong>Gesamtstatus:</strong></span>
        @if (!(isValid$ | async)) {
          <span
            style="color:red; font-size: smaller; "><i
          style="font-size: x-small !important;" class="pi pi-circle-fill"></i>&nbsp;Fehlerhafte
        Zeilen!</span>
      }
      @if (!(((rowValues$ | async).length >= (minimum$ | async)) &&
        ((rowValues$ | async).length <= (maximum$ | async))) ) {
        <span
          style="color:red; font-weight: bold; font-size: smaller; "><i style="margin-right: 5px;"
        class="pi pi-circle-fill" style="font-size: x-small !important;"></i>&nbsp;Anzahl Zeilen!</span>
      }
      @if ((isValid$ | async) &&
        (((rowValues$ | async).length >= (minimum$ | async))  &&
        (((rowValues$ | async).length <= (maximum$ | async) || ((maximum$ | async) == 0))))) {
        <span
          style="color:darkgray; font-size: smaller; "><i style="margin-right: 5px;"
        class="pi pi-circle"></i>Freigabe möglich</span>
      }
    </div>
  }
  @if (this.taskType == 'articledata' && !isManager) {
    <div style="margin-top: 10px">
      <span style="margin-left: 15px;"><strong>Gesamtstatus:</strong></span>
      @if (!(isValid$ | async)) {
        <span
          style="color:red; font-size: smaller; "><i
        style="font-size: x-small !important;" class="pi pi-circle-fill"></i>&nbsp;Fehlerhafte Zeilen!</span>
      }
      @if ((selectSingleTask$ | async)?.data?.taskState < 400 ) {
        <span
          style="color:darkgray; font-size: smaller; "><i style="margin-right: 5px;"
        class="pi pi-circle"></i>Freigabe möglich</span>
      }
      @if ((selectSingleTask$ | async)?.data?.taskState > 400 ) {
        <span
          style="color:green; font-size: smaller; "><i style="margin-right: 5px;"
        class="pi pi-check"></i></span>
      }
    </div>
  }
</ng-template>
</p-toolbar>


@if ((rowValues$ | async).length > 0 && columnHeaders().length > 0) {
  <div >
    <p-table [columns]="columnHeaders()" [value]="rowValues$ | async" scrollHeight="70vH" scrollable="true"
      editMode="row"
      [resizableColumns]="true" dataKey="id" [paginator]="true"
      [reorderableColumns]="true"
      stateStorage="session"
      [stateKey]="lStateKey"
      (onStateSave)="onStateSave($event)"
      styleClass="p-datatable-sm " columnResizeMode="expand" [paginator]="true"
      [showGridlines]="true"
      [rowsPerPageOptions]="[10, 20, 50, 100]" paginatorDropdownAppendTo="body" [rows]="rows" [scrollable]="true"
      [first]="first"
      [currentPageReportTemplate]="'{first} bis {last} von {totalRecords}'" [showCurrentPageReport]="true"
      [loading]="contentListisLoading$ | async" #ptlist>
      <ng-template pTemplate="header" let-columns="columns">
        <tr style="height: 3rem;">
          @if (hasValidationColumn()) {
            <th pFrozenColumn [frozen]="true" pResizableColumnDisabled style="min-width:50px !important; max-width:50px !important"><i
            class="pi pi-ellipsis-v"></i></th>
          }
          @if (hasAllCheckBox()) {
            <th  pFrozenColumn [frozen]="true"
              pResizableColumnDisabled style="width: 50px; min-width: 50px !important ; max-width: 50px  !important; ">
              <p-checkbox   binary="true" [(ngModel)]="selectallRows"
                (onChange)="selectallRowsForActions($event)"
              ></p-checkbox>
            </th>
          } @else {
            @if (hasCheckColumn()) {
              <th #singlecheckbox  pFrozenColumn [frozen]="true"
                pResizableColumnDisabled style="width: 50px; min-width: 50px !important; max-width: 50px  !important; "><i
              class="pi pi-check"></i></th>
            }
          }
          @for (col of columnHeaders(); track col) {
            <th [style]="getColWidth(col, {})" pReorderableColumn  pResizableColumn >
              @if (!col.ismandatory) {
                <div pTooltip="{{ getToolTip(col.field, col.columndesc) }}"
                tooltipPosition="bottom">{{ col.field  }}</div>
              }
              @if (col.ismandatory) {
                <div pTooltip="{{ getToolTip(col.field, col.columndesc) }}"
                tooltipPosition="bottom">* {{ col.field  }}</div>
              }
              <!-- Simple Text Filter -->
            </th>
          }
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns" let-editing="editing" let-rowIndex="rowIndex">
        <tr style="height: 3rem">
          @if (hasValidationColumn()) {
            <td style="width: 50px; min-width:50px !important; max-width:50px !important" pFrozenColumn pResizableColumnDisabled >
              @if (rowDataIsValid(rowData) == false) {
                <div style="color:red" pTooltip="{{rowData.validationInfo}}">
                  <i class="pi pi-circle-fill"></i>
                </div>
              }
              @if (rowDataIsValid(rowData) == true) {
                <div style="width:3rem; color:lightgray"><i
                class="pi pi-circle"></i></div>
              }
            </td>
          }
          @if (hasCheckColumn() || hasAllCheckBox()) {
            <td  style="width: 50px;  min-width: 50px !important; max-width: 50px !important; overflow: visible;"      pFrozenColumn >
              @if (isUploadStateOpenCheckBox()) {
                <p-checkbox [disabled]="!canCheckBoxSelection()"
                binary="true" [(ngModel)]="rowData.selected" (onChange)="selectForActions(rowData)"></p-checkbox>
              }
              @if (isUploadStateFinshedCheckBox()) {
                <p-checkbox [disabled]="!canCheckBoxSelection()"
                  binary="true" [(ngModel)]="rowData.selected" (onChange)="selectForActions(rowData)"
                [readonly]="isCheckboxReadOnly(rowData)"></p-checkbox>
              }
            </td>
          }
          @for (col of columnHeaders() ; track col) {
            <td [style]="getColWidth(col, {'overflow': 'visible','white-space' : 'no-wrap', 'overflow-x':'hidden'})" [pEditableColumn]="rowData"
              [pEditableColumnField]="col.field" [pEditableColumnRowIndex]="rowIndex"
              [pEditableColumnDisabled]="!this.isRowsEditing()"
              pTooltip="{{ getToolTip(col.field, col.columndesc) }}"
              [ngClass]="gettdStyle(col)" >
              <!-- EAN / ISBN -->
              @if (col.columncelltype == 9) {
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText [id]="col.usedcolumnid+col.field" [disabled]="(isReadOnly$ | async) == 1" type="text"
                      (ngModelChange)="onTextChanged($event, rowData, col)"
                      [(ngModel)]="rowData.cols[col.usedcolumnid].value" [style]="{'width':'100%'}" ngClass="inputText">
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ rowData.cols[col.usedcolumnid].value }}
                  </ng-template>
                </p-cellEditor>
              }
              <!-- Simple TextCell -->
              @if (col.columncelltype == 0) {
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <input pInputText [id]="col.usedcolumnid+col.field" [disabled]="(isReadOnly$ | async) == 1" type="text"
                      (ngModelChange)="onTextChanged($event, rowData, col)"
                      [(ngModel)]="rowData.cols[col.usedcolumnid].value" [style]="{'width':'100%'}" ngClass="inputText">
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ rowData.cols[col.usedcolumnid].value }}
                  </ng-template>
                </p-cellEditor>
              }
              <!-- Number -->
              @if (col.columncelltype == 1) {
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-inputNumber [inputId]="col.usedcolumnid+col.field" [disabled]="(isReadOnly$ | async) == 1"
                      (ngModelChange)="onNumberChanged($event, rowData, col)"
                      [mode]="'decimal'"
                      [useGrouping]="false"
                      [styleClass]="'w-full'"
                      [step]="0"
                  [min]="selectValidationsbyUsedColumnId()[col.usedcolumnid]?.minNumber ?
                  selectValidationsbyUsedColumnId()[col.usedcolumnid]?.minNumber : null                  "
                      [showButtons]="false"
                  [maxFractionDigits]="selectValidationsbyUsedColumnId()[col.usedcolumnid]?.maxDigits ?
                    selectValidationsbyUsedColumnId()[col.usedcolumnid]?.maxDigits :
                    (selectValidationsbyUsedColumnId()[col.usedcolumnid]?.isNumberOnly == 1 ? 0 :  2)"
                    [(ngModel)]="rowData.cols[col.usedcolumnid].value"></p-inputNumber>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ rowData.cols[col.usedcolumnid].value | number:'1.0-2':'de' }}
                  </ng-template>
                </p-cellEditor>
              }
              <!-- Checkbox -->
              <!--  Problem mit initial disabled     @if(col.columncelltype == 2 ) {
              <p-checkbox [disabled]="!canEditCheckBox()" [id]="col.usedcolumnid+col.field"
                [binary]="true"
                (onChange)="oncheckboxChanged($event, rowData, col)"
              [ngModel]="rowData.cols[col.usedcolumnid].booleanValue"></p-checkbox>
              } -->
              @if(col.columncelltype == 2 ) {
                <input type="checkbox" [disabled]="canEditCheckBox() == false" [id]="col.usedcolumnid+col.field"
                  class="checkboxStyle p-checkbox p-checkbox-box p-checkbox-icon " binary="true"
                  (ngModelChange)="oncheckboxChanged($event, rowData, col)"
                  [ngModel]="rowData.cols[col.usedcolumnid].booleanValue"/>
              }
              <!-- List -->
              @if (col.columncelltype == 3) {
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select [inputId]="col.usedcolumnid+'-'+rowIndex"  optionLabel="label"
                      [disabled]="(isReadOnly$ | async) == 1" [showClear]="true"
                      (onFocus)="this.createStaticComboList(rowData.cols[col.usedcolumnid], col);"
                      [options]="staticOptions()[col.usedcolumnid]"
                      [style]="{'width':'100%', 'overflow': 'visible'}"
                      (onChange)="dropdownChanged($event, rowData, col)" class="tdDropdownStyle"
                    [ngModel]="getStaticModel(rowData.cols[col.usedcolumnid], col)" appendTo="body"></p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ rowData.cols[col.usedcolumnid].value  }}
                  </ng-template>
                </p-cellEditor>
              }
              <!-- Dynamic List , wird zur Laufzeit ermittelt-->
              @if (col.columncelltype == 8) {
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-select [inputId]="col.usedcolumnid+'-'+rowIndex" optionLabel="label"
                      [disabled]="(isReadOnly$ | async) == 1" [showClear]="true"
                      [style]="{'width':'100%', 'overflow': 'visible'}"
                      [showClear]="true"
                      (onClear)="ondyndropdownClear($event, rowData, col)"
                      (onFocus)="createDynComboList(rowData.cols[col.usedcolumnid], col)"
                      [options]="dynOptions()[col.usedcolumnid]"
                      (onChange)="dyndropdownChanged($event, rowData, col)" class="tdDropdownStyle"
                    [ngModel]="getDynModel(rowData.cols[col.usedcolumnid], col)" appendTo="body"></p-select>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ getDynModel(rowData.cols[col.usedcolumnid], col)?.label }}
                  </ng-template>
                </p-cellEditor>
              }
              <!-- Date -->
              @if (col.columncelltype == 6) {
                <p-cellEditor>
                  <ng-template pTemplate="input">
                    <p-datepicker [inputId]="col.usedcolumnid+col.field" [disabled]="(isReadOnly$ | async) == 1"
                      (ngModelChange)="onDateChanged($event, rowData, col)"
                      [ngModel]="rowData.cols[col.usedcolumnid].datevalue" dataType="date" [firstDayOfWeek]=1
                    dateFormat="dd.mm.yy" [firstDayOfWeek]="1" appendTo="body"></p-datepicker>
                  </ng-template>
                  <ng-template pTemplate="output">
                    {{ rowData.cols[col.usedcolumnid].datevalue | date: 'dd.MM.yyyy' : 'de' }}
                  </ng-template>
                </p-cellEditor>
              }
            </td>
          }
        </tr>
      </ng-template>
    </p-table>
    @if ((rowValues$ |async).length === 0) {
      <div class="row h4">
        <div style="text-align: center;">Bitte Dokument hochladen oder Plus drücken für ein neues Dokument</div>
      </div>
    }
  </div>
}

<p-confirmDialog header="Bitte bestätigen:" icon="pi pi-exclamation-triangle"
message="{{ selectedRows.length }} Zeilen werden gelöscht." rejectLabel="Abbrechen"></p-confirmDialog>
